import React, { useState } from 'react'
import { QrReader } from 'react-qr-reader'
import { Button, message, Modal } from 'antd'
import { ScanOutlined, CloseOutlined } from '@ant-design/icons'
import { translations } from '../../utils/constants'

const QRCodeScanner = ({ onScan ,language}) => {
    const [scannerActive, setScannerActive] = useState(false)
    const [isModalVisible, setIsModalVisible] = useState(false)

    const handleScan = (data) => {
        if (data?.text) {
            onScan(data.text)
            setIsModalVisible(false)
        }
    }

    const handleError = (err) => {
        // console.error('Camera error:', err)
        message.error('Please allow camera access in your browser settings.')
    }

    const handleOpenScanner = () => {
        setIsModalVisible(true)
    }

    const handleCloseScanner = () => {
        setIsModalVisible(false)
    }

    return (
        <div className='qrcod-scanner'>
            <Button
                onClick={handleOpenScanner}
                className='scan-qrbutton'
                icon={<ScanOutlined />}
            >
                
                {translations[language]?.scanQr}
            </Button>
            <Modal
                title={translations[language]?.qrCodeScannerTitle}
                // title="QR Code Scanner"
                visible={isModalVisible}
                onCancel={handleCloseScanner}
                footer={null}
                destroyOnClose={true}
                centered
                width={300}
                zIndex={2000}
                getContainer={false}
            >
                <div className='scannerActive'>
                    <QrReader
                        delay={300}
                        style={{
                            width: '100%',
                            margin: '0 auto',
                        }}
                        onResult={handleScan}
                        onError={handleError}
                        // facingMode={{ exact: 'environment' }}
                        
                        constraints={{
                            facingMode: 'environment' // Forces back camera
                        }}/>
                </div>
            </Modal>
        </div>
    )
}

export default QRCodeScanner
